import { render, staticRenderFns } from "./TebligatTuruPicker.vue?vue&type=template&id=79899abe"
import script from "./TebligatTuruPicker.vue?vue&type=script&lang=ts"
export * from "./TebligatTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports